// src/components/admin/settings/AboutPageSettings.jsx
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import './SettingsPages.css';

const AboutPageSettings = () => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState({});

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await fetch('https://demo-site.storii.com.pk/demo-api/public/get-settings.php');
      const data = await response.json();
      if (data.success && data.settings) {
        setSettings(data.settings);
      }
    } catch (error) {
      console.error('Error loading settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = async (e, imageKey) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);
    setUploading(prev => ({ ...prev, [imageKey]: true }));

    try {
      const response = await fetch('https://demo-site.storii.com.pk/demo-api/admin/upload-about-image.php', {
        method: 'POST',
        body: formData
      });
      const data = await response.json();
      if (data.success) {
        setSettings({ ...settings, [imageKey]: data.image_url });
        toast.success('Image uploaded!');
      } else {
        toast.error(data.message || 'Upload failed');
      }
    } catch (error) {
      toast.error('Connection error');
    } finally {
      setUploading(prev => ({ ...prev, [imageKey]: false }));
    }
  };

  const handleChange = (e) => {
    setSettings({ ...settings, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const response = await fetch('https://demo-site.storii.com.pk/demo-api/admin/update-settings-simple.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(settings)
      });
      const data = await response.json();
      if (data.success) {
        toast.success('About page saved!');
      } else {
        toast.error('Failed to save');
      }
    } catch (error) {
      toast.error('Connection error');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="loader">Loading about page...</div>;

  return (
    <div className="settings-page">
      <h2>About Page Settings</h2>
      
      <form onSubmit={handleSubmit} className="settings-form">
        <div className="form-group">
          <label>Hero Title</label>
          <input type="text" name="about_hero_title" value={settings.about_hero_title || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Hero Subtitle</label>
          <input type="text" name="about_hero_subtitle" value={settings.about_hero_subtitle || ''} onChange={handleChange} />
        </div>
        
        <hr className="section-divider" />
        <h3>Our Story Section</h3>
        <div className="form-group">
          <label>Story Title</label>
          <input type="text" name="about_story_title" value={settings.about_story_title || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Story Text</label>
          <textarea name="about_story_text" value={settings.about_story_text || ''} onChange={handleChange} rows="4" />
        </div>
        <div className="form-group">
          <label>Story Image</label>
          {settings.about_story_image && (
            <div className="image-preview">
              <img src={`${settings.about_story_image}?t=${Date.now()}`} alt="Story" />
              <button type="button" className="remove-img-btn" onClick={() => setSettings({ ...settings, about_story_image: '' })}>Remove</button>
            </div>
          )}
          <input type="file" accept="image/*" onChange={(e) => handleImageUpload(e, 'about_story_image')} />
        </div>
        
        <hr className="section-divider" />
        <h3>Our Mission Section</h3>
        <div className="form-group">
          <label>Mission Title</label>
          <input type="text" name="about_mission_title" value={settings.about_mission_title || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Mission Text</label>
          <textarea name="about_mission_text" value={settings.about_mission_text || ''} onChange={handleChange} rows="4" />
        </div>
        <div className="form-group">
          <label>Mission Image</label>
          {settings.about_mission_image && (
            <div className="image-preview">
              <img src={`${settings.about_mission_image}?t=${Date.now()}`} alt="Mission" />
              <button type="button" className="remove-img-btn" onClick={() => setSettings({ ...settings, about_mission_image: '' })}>Remove</button>
            </div>
          )}
          <input type="file" accept="image/*" onChange={(e) => handleImageUpload(e, 'about_mission_image')} />
        </div>
        
        <hr className="section-divider" />
        <h3>Team Section</h3>
        <div className="form-group">
          <label>Team Title</label>
          <input type="text" name="about_team_title" value={settings.about_team_title || ''} onChange={handleChange} />
        </div>
        
        {[1, 2, 3].map((num) => (
          <div key={num} className="team-card">
            <h4>Team Member {num}</h4>
            <div className="form-group">
              <label>Name</label>
              <input type="text" name={`about_team_member_${num}_name`} value={settings[`about_team_member_${num}_name`] || ''} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Role</label>
              <input type="text" name={`about_team_member_${num}_role`} value={settings[`about_team_member_${num}_role`] || ''} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Team Member Image</label>
              {settings[`about_team_member_${num}_image`] && (
                <div className="image-preview">
                  <img src={`${settings[`about_team_member_${num}_image`]}?t=${Date.now()}`} alt="Team" />
                  <button type="button" className="remove-img-btn" onClick={() => setSettings({ ...settings, [`about_team_member_${num}_image`]: '' })}>Remove</button>
                </div>
              )}
              <input type="file" accept="image/*" onChange={(e) => handleImageUpload(e, `about_team_member_${num}_image`)} />
            </div>
          </div>
        ))}
        
        <button type="submit" disabled={saving} className="save-btn">{saving ? 'Saving...' : 'Save About Page'}</button>
      </form>
    </div>
  );
};

export default AboutPageSettings;